
import Carousel from 'primevue/carousel'

export default {
  components: {
    Carousel
  },
  props: {
    showNavs: {
      type: Boolean,
      default: true
    },
    orientation: {
      type: String,
      default: 'horizontal'
    }
  },
  computed: {
    vertical() {
      return this.orientation === 'vertical'
    }
  },
  mounted() {
    if (this.showNavs && this.vertical) this.replaceDots()
  },
  methods: {
    replaceDots() {
      const parent = this.$refs.carousel.$el.querySelector('.p-carousel-content')
      const indicators = this.$refs.carousel.$el.querySelector('.p-carousel-indicator-list')
      parent.append(indicators)
    }
  }
} 
